import React from 'react'

interface TextareaProps {
    rowCount: number;
    required: boolean;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    placeholder: string
}

export default function Textarea({ rowCount, required, value, onChange, placeholder } : TextareaProps) {
  return (
    <textarea 
        className='text-xs block w-full rounded border border-gray-300 px-3 py-2 shadow-sm outline-none placeholder:text-gray-400 focus:border-black'
        rows={rowCount}
        required={required}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
    />
  )
}
